module.exports = __webpack_public_path__ + "img/icon_aside_illustration_active.f6a4304b.svg";